/** Colour per country code for the Flag chip. These are national colours,
 * i.e. content, so they stay literal on every theme. */
export const FLAG_COLORS: Record<string, string> = {
  SI: "#005DA4", DE: "#000000", FR: "#0055A4", IT: "#008C45", ES: "#AA151B", AT: "#ED2939",
  PL: "#DC143C", HU: "#477050", CZ: "#11457E", HR: "#171796", RS: "#0C4076", RO: "#002B7F",
  BG: "#00966E", GR: "#0D5EAF", TR: "#E30A17", NL: "#AE1C28", SE: "#006AA7", NO: "#BA0C2F",
  DK: "#C8102E", FI: "#003580", UK: "#012169", US: "#3C3B6E",
};
export const FLAG_FALLBACK = "#666666";
